import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, Box } from '@mui/material';

import NavBar from './NavBar';
import PiersModule from './modules/piers/PiersModule';
import TPDashboard from './components/TPDashboard';
import AlgorithmExplainer from './components/AlgorithmExplainer';
import StationSelect from './components/StationSelect';
import theme from './theme';
import { AppThemeProvider } from './contexts/ThemeContext';

const App = () => {
  return (
    <AppThemeProvider>
      <ThemeProvider theme={theme}>
        <Router>
          <NavBar />
          <Box sx={{ height: 64 }} />
          <Routes>
            <Route path="/" element={<StationSelect />} />
            <Route path="/piers/:station/*" element={<PiersModule />} />
            <Route path="/tp-dashboard" element={<TPDashboard />} />
            <Route path="/how-it-works" element={<AlgorithmExplainer />} />
            {/* Any unmatched URL (e.g. a bookmarked bare /piers from the
                pre-multi-station days) falls back to the station chooser
                instead of rendering a blank page. */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </AppThemeProvider>
  );
};

export default App;
